/* 🤖 this file was generated by script */
export const wsolidiconFlag01 = {
  name: 'flag_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M3 3q0-.4.3-.7s-.05.03.04-.05l.3-.24q.3-.2.86-.44A9 9 0 0 1 8 1c1.7 0 3.1.56 4.32 1.05l.05.02c1.27.5 2.35.93 3.63.93 1.39 0 2.26-.23 2.75-.43a3 3 0 0 0 .57-.3A1 1 0 0 1 21 3v12a1 1 0 0 1-.3.7q-.05.07-.11.11l-.24.18q-.3.2-.85.44A9 9 0 0 1 16 17c-1.7 0-3.1-.56-4.32-1.05l-.05-.02A10 10 0 0 0 8 15a7.4 7.4 0 0 0-3 .54V22a1 1 0 1 1-2 0V3"/></svg>`,
  iconStyle: 'solid',
};
